
import { useStore } from 'vuex'
import { useRoute } from 'vue-router'
import { GetUserInfo } from '@/apis/user'
import { TOKENKEY } from '@/config/constant'
import { usePlatformInfo } from '@/compositions/common'
import appHost, { isApp, judgeHasGetBaseInfo, isAndrod } from '@/utils/app'
import { getEntryInfo, setStorage } from '@/utils'
import { setGlobelHeader } from '@/utils/request'
import { computed, defineComponent, onMounted, ref, watch } from 'vue'
import type { CSSProperties } from 'vue'
import { setNFBottomOperatorBar } from '@/utils/tools'
import KeepAliveRouterView from '@/components/KeepAliveRouterView.vue'
const allowRouteName: string[] = [
  'map-previce',
  'home',
  'login',
  'maptalk',
  'AppView',
  'about',
  'expect',
  'registration-invitation',
]
const shuoldLoadingUserInfoRouteName: string[] = [
  'networkpoints',
  'networkpoint-list',
  'networkpoint-detail',
  'train-network',
  'train-network-list',
  'train-network-detail',
]

export default defineComponent({
  name: 'app-index',
  components: { KeepAliveRouterView },
  setup() {
    const store = useStore()
    const route = useRoute()
    const { isLandscape } = usePlatformInfo()
    const userInfoLoading = ref(true)

    const loading = ref(isApp && judgeHasGetBaseInfo())
    const getAppContainerStyle = computed(() => {
      // 添加操作栏旧农服版本底部样式
      let fixBottomStyle: CSSProperties = {}
      let { needFixRoute, isCanUse, ishasSetNavBarHandle } = setNFBottomOperatorBar()
      if (isCanUse && !ishasSetNavBarHandle && needFixRoute.includes(route.matched[0].path)) {
        fixBottomStyle = {
          paddingBottom: '45px',
        }
        // 设置弹窗底部
        import('@/assets/fix-nf-operator.scss')
      }
      const safeInfo = store.state.safeAreaInfo
      if (!isLandscape.value) {
        return {
          'padding-left': 0,
          ...fixBottomStyle,
        }
      }
      return {
        'padding-left': safeInfo.left + 'px',
        ...fixBottomStyle,
      }
    })
    // const loading = ref(true)
    function initUserInfo() {
      // 默认userInfoLoading为true，在此处判断不是需要用户信息的路由时，直接设为false

      if (shuoldLoadingUserInfoRouteName.indexOf(route.name as string) === -1) {
        userInfoLoading.value = false
      }
      if (loading.value && !userInfoLoading.value) {
        return
      }
      const allowRouteNameList = allowRouteName.concat(
        getEntryInfo().isFromMemberUnToken ? [...shuoldLoadingUserInfoRouteName] : []
      )
      if (!allowRouteNameList.includes(route.name as string) && !store.getters.userGuid) {
        GetUserInfo()
          .then((data) => {
            store.commit('setUserInfo', data)
          })
          .finally(() => {
            userInfoLoading.value = false
          })
      } else {
        userInfoLoading.value = false
      }
    }
    watch(
      () => route.name,
      () => {
        initUserInfo()
      }
    )
    async function initAppBaseInfo() {
      try {
        const data = await appHost.getAppBaseInfo()
        let displayMode = ''
        let safeAreaInfo = null
        try {
          displayMode = await appHost.getDisplayMode()
        } catch (error) {
          console.log('error', error)
        }
        try {
          safeAreaInfo = await appHost.getLandscapeScreenSafeArea()
        } catch (error) {
          console.log('error', error)
        }
        const token = data?.token
        setGlobelHeader('token', token)
        setStorage(TOKENKEY, token)
        loading.value = false
        initUserInfo()
        store.commit('setAppPlatformInfo', {
          displayMode,
          platform: data?.platform,
          safeAreaInfo,
        })
      } catch (error) {
        console.log('initAppBaseInfo error', error)
      }
    }

    if (loading.value) {
      initAppBaseInfo()
    }
    onMounted(async () => {
      let canNext = true
      if (isAndrod) {
        let version: string | number = await appHost.getNFAppVersion()
        console.log('version', version, typeof version)
        version = Number(version)
        canNext = version === 1 || version >= 615
      }
      console.log('canNext', canNext)
    })
    return {
      loading,
      getAppContainerStyle,
      userInfoLoading,
    }
  },
})
